/**
 * @Description:  获取ip Node.js 的 os 模块提供了一些基本的系统操作函数
 * @param:
 * @Author: ZhangBin
 * @Date 2019-08-06 11:14
 */

const os = require('os'), host = os.hostname();
module.exports = 'http://' + host || 'http://127.0.0.1';



// WEBPACK FOOTER //
// ./src/config/getHost.js